/**
 * External Dependencies
 */
import { get, flatten } from 'lodash';

/**
 * Internal dependencies
 */
import getCubeMeta from './get-cube-meta';

export default (state) => {
    const cubes = get(getCubeMeta(state), ['cubes'], []);
    return flatten(cubes.map(({ segements }) => segements));
};
